import axios from "../utils/axios";


export function userCreate(data, idToken, callback, errorcallback) {

}

export function userEdit(data, callback, errorcallback) {
    axios.put(process.env.REACT_APP_API_SERVER + '/user/edit/' + data._id, data).then(response => {
        if (callback != null) {
            callback(response);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });


}

export function userGetByEmail(username, callback, errorcallback) {
    axios.get(process.env.REACT_APP_API_SERVER + '/user/email/' + username).then(response => {
        if (callback != null) {
            callback(response);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}